// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"fc4faef2","54":"b6ced7b2","191":"ba3cdfb6","369":"4e5959d5","394":"63b10de5","453":"bf3f29e4","455":"abb21ead","616":"952fcdaf","620":"cef8dafb","698":"d85a06c1","744":"09c0052a","813":"d089cb28","971":"ea85fa78","977":"9daf63ae"}[chunkId] + ".chunk.js";
};